import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { Skins } from "../../components/Loader/Skins";
import { Field, Form, Formik } from "formik";
import { Oval } from "react-loader-spinner";
import * as Yup from "yup"
import { resetPassword } from "../../services";
import { Toast } from "../../components/Toast/Toast";

export const ResetPassword = () => {
    const navigate = useNavigate("")
    const [params] = useSearchParams()
    const token = params.get('token');
    const email = params.get('email');
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState('');
    const initialValues = {
        password: "",
        passwordConfirmation: ""
    }

    const handleSubmit = values => {
        setIsSubmitting(true);
        resetPassword(token, email, values.password, values.passwordConfirmation).then(response => {
            const data = response.data;
            setIsSubmitting(false);
            navigate("/login")
            console.log(data);
        }).catch(err => {
            setIsSubmitting(false);
            setMessage(err.response.data.message)
            console.error(err);
        })
    }

    const ResetSchema = Yup.object().shape({
        password: Yup.string().required('Password is required').min(8),
        passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match')
    })
    return (
        <main className="flex flex-col items-center justify-center has-black-bg has-full-height">
            {isLoading ? (
                <Skins />
            ) : (
                <article className="flex flex-col items-start justify-center">
                    <h1 className="text-6xl text-light-grey font-light">Reset Password</h1>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={values => handleSubmit(values)}
                        validationSchema={ResetSchema}
                    >
                        {({ errors, touched }) => (
                            <Form className="w-full">
                                <fieldset className="flex flex-col gap-3 mt-5 mb-5">
                                    <Field
                                        name="password"
                                        type="password"
                                        placeholder="New Password"
                                        className="has-border-bottom"
                                    />
                                    {errors.password && (
                                        <span className="has-red-text w-full text-xs mt-1">{errors.password}</span>
                                    )}
                                </fieldset>
                                <fieldset className="flex flex-col gap-3 mt-5 mb-5">
                                    <Field
                                        name="passwordConfirmation"
                                        type="password"
                                        placeholder="Re-enter Password"
                                        className="has-border-bottom"
                                    />
                                    {errors.passwordConfirmation && (
                                        <span className="has-red-text w-full text-xs mt-1">{errors.passwordConfirmation}</span>
                                    )}
                                </fieldset>
                                <button className="btn btn-login w-full" type="submit">
                                    {isSubmitting ? (
                                        <Oval
                                            height={30}
                                            width={50}
                                            color="black"
                                            secondaryColor="black"
                                        />
                                    ) : (
                                        <span className="text-black">Reset</span>
                                    )}
                                </button>
                            </Form>
                        )}
                    </Formik>
                    {message && (
                        <Toast message={message} />
                    )}
                </article>
            )}
        </main>
    )
}